export default "__VITE_ASSET__Bmt0tUeA__"